<!-- search bar -->
<div class="content-wrap">
    <div class="container">
        <div class="breadcrumb">
            <app-bread-crumb [data]="breadCrumb"></app-bread-crumb>
        </div>
        <div class="title-catalogue d-flex justify-content-between align-items-center">
            <h2>{{ 'IRONSIDE.contact-page.contact' | translate }}</h2>
        </div>
    </div>
</div>
<div class="container contact-page-content">
    <!-- <ng-container *ngIf="loading">
        <div class="secsion-loading">
            <mat-spinner [diameter]="50"></mat-spinner>
        </div>
    </ng-container> -->
    <div class="content-wrap">
        <div class="info-left">
            <img src="assets/logo/logo-ironside.png" alt="" />
            <div class="secsion-info">
                <span style="font-weight: 700">Ironside International scrl</span>
                <span>B.P. 41031-Paris-Nord 2</span>
                <span>13 rue de la perdrix -Tremblay-en-France</span>
                <span>F-95912 Roissy CDG CEDEX-FRANCE</span>
                <span>V.A.T.: FR 90380279117</span>
                <span>Tel. 33 (0)1 49 89 39 39</span>
                <span>info@ironsideinternational.com</span>
                <span>www.ironside.eu</span>
            </div>
        </div>
        <div class="info-right">
            <div class="table-product">
                <table>
                    <thead>
                        <tr>
                            <th>{{ 'IRONSIDE.contact-page.first-name-last-name' | translate }}</th>
                            <th>{{ 'IRONSIDE.contact-page.phone' | translate }}</th>
                            <th>{{ 'IRONSIDE.contact-page.mobile' | translate }}</th>
                            <th>{{ 'IRONSIDE.contact-page.email' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="contacts">
                        <tr *ngFor="let contact of contacts">
                            <td>{{ contact?.firstName }} {{ contact?.lastName }}</td>
                            <td>
                                <ng-container *ngIf="contact?.phone; else elseTemplateNotPhone">
                                    <a href="tel:{{ contact?.phone }}">{{ contact?.phone }}</a>
                                </ng-container>
                                <ng-template #elseTemplateNotPhone>
                                    <p>-</p>
                                    <p>-</p>
                                </ng-template>
                            </td>
                            <td>
                                <ng-container *ngIf="contact?.mobile; else elseTemplateNotMobile">
                                    <a href="tel:{{ contact?.mobile }}">{{ contact?.mobile }}</a>
                                </ng-container>
                                <ng-template #elseTemplateNotMobile>
                                    <p>-</p>
                                    <p>-</p>
                                </ng-template>
                            </td>
                            <td>
                                <a href="mailto:{{ contact?.email }}">{{ contact?.email }}</a>
                            </td>
                        </tr>
                    </tbody>

                    <tbody *ngIf="loading">
                        <tr *ngFor="let _ of [1,2,3,4,5]">
                            <td><p-skeleton></p-skeleton></td>
                            <td><p-skeleton></p-skeleton></td>
                            <td><p-skeleton></p-skeleton></td>
                            <td><p-skeleton></p-skeleton></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
